import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {NotificationProps} from '../types';
import notificationsKeys from '../util/notifications-keys';

export interface CreateNotificationProps
  extends Omit<NotificationProps, 'id'> {}

const useCreateNotification = () => {
  const {create} = useInfiniteQueryHelpers();

  const onSuccess = (data: NotificationProps) =>
    create(notificationsKeys.list(), data);

  return useApiMutation<NotificationProps>({
    url: '/notifications',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar notificação',
    successTitle: 'Cadastrar notificação',
    successMessage: 'Notificação cadastrada com sucesso',
    redirectUrl: '/marketing/notifications',
    onSuccess,
  });
};

export default useCreateNotification;
